

import formMaintenance from './form-maintenance/index'
import miteeForm from './mitee-form/index'
import miteeProtype from './mitee-protype/index'
import SuperTable from './SuperTable/index'
import formUserManage from './form-maintenance-userManage/index'
import pageMaintenanceApi from './page-maintenance-api/index'
import miteeRoleMenuManage from './form-maintenance-roleMenuManage/index';
import superTitle from './super-title/index'
import superTable from './super-table/index'
import searchTime from './search-time/index'
import pagination from './pagination/index'
import formCom from './form-com/index'

// 存储组件列表
const components = [
    formMaintenance,
    miteeForm,
    miteeProtype,
    SuperTable,
    formUserManage,
    pageMaintenanceApi,
    miteeRoleMenuManage,
    superTitle,
    superTable,
    searchTime,
    pagination,
    formCom
]

// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (Vue) {
  // 判断是否安装
  if (install.installed) return
  // 遍历注册全局组件
  components.map(component =>{
   
    Vue.component(component.name, component)
  })
}

// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
    // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
    install,
    // 以下是具体的组件列表
    formMaintenance,
    miteeForm,
    miteeProtype,
    SuperTable,
    formUserManage,
    pageMaintenanceApi,
    miteeRoleMenuManage,
    superTitle,
    superTable,
    searchTime,
    pagination,
    formCom
}